import React, { useState } from "react";
import styled from "styled-components";
import { ChannelContext } from "../../../context/channel";
import { DEFAULT_PRIMARY_COLOR } from "../../../pages/university/Home";
import Button, { IButtonProps } from "../../shared/button/Button";

interface IMenuTitle {
  colorHover: string;
}

type MenuItem = {
  title: string;
  slug: string;
  handleClick: (title: string) => void;
};

type IButtonDropdown = {
  className?: string;
  title: string;
  menus: MenuItem[];
  buttonProps?: IButtonProps;
};

const ButtonMenu = styled.a`
  margin-top: 8px;
  width: 100%;
  border: none;
  background-color: transparent;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  color: ${(props) => props.theme.colors.secondary};
  :hover& {
    border-radius: 7px;
  }
`;

const MenuTitle = styled.span<IMenuTitle>`
  font-weight: 500;
  color: ${(props) => props.theme.colors.secondary};
    &:hover {
      color: ${(props) => props.colorHover}
    }
`;

const StyledMenu = styled.div`
  width: 215px;
  margin-top: 4px;
  border-radius: 8px;
  padding: 16px !important;
  padding-right: 24px !important;
  box-shadow: none;
  background-color: ${(props) => props.theme.colors.background};
  
  .ant-dropdown-menu-item {
    &:hover {
      background-color: transparent;
    }
  }

`;

const Layout = styled.div`
  position: relative;

  .overlay {
    z-index: 2;
    display: none;
  }

  .eventials-button {
    margin: 0;
    border-radius: 40px;
  }

  .menu-dropdown,
  button {
    z-index: 1001;
  }

  .menu-dropdown {
    height: 0;
    display: none;
    button {
      display: none;
    }
  }

  &:hover {
    button {
      position: relative;
    }

    .menu-dropdown {
      position: absolute;
      height: auto;
      display: block;

      button {
        display: block;
      }
    }

    .overlay {
      display: block;
      background-color: rgba(0, 0, 0, 0.2);
      width: 100vw;
      height: 100vh;
      position: fixed;
      bottom: 0;
      left: 0;

      &:hover {
        display: none;
      }
    }
  }
`;

const ButtonDropdown = ({
  menus,
  buttonProps,
  title,
  ...rest
}: IButtonDropdown) => {
  const { data } = React.useContext(ChannelContext)

  const [hover, setHover] = useState<boolean>(false);

  return (
    <>
      <Layout
        {...rest}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <Button {...buttonProps} forceHover={hover}>
          {title}
        </Button>
        <StyledMenu className="menu-dropdown">
          {menus.map(({ title: menuTitle, handleClick, slug }: MenuItem, index: number) => (
            <ButtonMenu key={index} type="button" onClick={() => handleClick(slug)}>
              <MenuTitle colorHover={data.config.colors?.colorPrimary ? data.config.colors.colorPrimary : DEFAULT_PRIMARY_COLOR }>{menuTitle}</MenuTitle>
              <br></br>
            </ButtonMenu>
          ))}
        </StyledMenu>
        <div className="overlay" />
      </Layout>
    </>
  );
};

ButtonDropdown.defaultProps = {
  buttonProps: {},
  className: "",
};

export default ButtonDropdown;
